// utils/getTimezone.ts
const getTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export default getTimezone;
